module.exports = __webpack_public_path__ + "static/Tanium-e968a8ddbe530e492bb231544a93403a.jpg";